<template>
  <div>
    <b-card
      :title="$t('Sub Accounts')"
    >
      <b-row class="justify-content-between">
        <b-col
          cols="2"
          class="mb-sm-1"
        >
          <b-form-group class="text-nowrap mb-0">

            <label class="d-inline-block  mr-50 text-sm-right font-small-4">{{ $t('Per page') }}</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="$tOptions(pageOptions)"
              class="w-50"
              style="min-width: 100px"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          lg="4"
          md="6"
          sm="8"
          class="mb-1"
        >
          <b-form-group
            :label="$t('Filter')"
            label-cols-sm="3"
            label-align-sm="right"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filterForSearch"
                type="search"
                :placeholder="$t('Type prefix or username to search')"
                @keydown.enter="filterSearch"
              />
              <b-input-group-append>
                <b-button
                  @click="filterSearch"
                >
                  {{ $t('Search') }}
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-table
            ref="table"
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="reloadData"
            :fields="$tFields(fields)"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :busy.sync="loading"
            :filter="filter"
            :small="small"
          >
            <template #cell(ability)="data">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon"
                @click="getAbility(data.item.username)"
              >
                {{ $t('view') }}
              </b-button>
            </template>
            <template #cell(edit)="data">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                class="btn-icon"
                @click="$router.push(`sub-account/edit?id=${data.item.username}`)"
              >
                <feather-icon icon="Edit3Icon" />
              </b-button>
            </template>

            <template #cell(delete)="data">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="flat-primary"
                class="btn-icon"
                @click="onDelete(data.item.username)"
              >
                <feather-icon icon="ArchiveIcon" />
              </b-button>
            </template>

            <template #cell(totpStatus)="data">
              <div class="d-flex align-items-center justify-content-center flex-nowrap">
                <b-button
                  v-if="canResetTotp(data.item)"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  size="sm"
                  variant="outline-primary"
                  class="text-nowrap"
                  :disabled="totpResettingUsername === data.item.username"
                  @click="resetTotp(data.item)"
                >
                  {{ $t('Reset 2FA') }}
                </b-button>
                <b-badge
                  v-else
                  :variant="getTotpStatusVariant(data.item)"
                  class="text-nowrap"
                >
                  {{ getTotpStatusText(data.item) }}
                </b-badge>
              </div>
            </template>
          </b-table>
        </b-col>

        <b-col
          cols="12"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="abilityDisble"
      cancel-variant="secondary"
      ok-only
      :ok-title="$t('Submit')"
      centered
      :title="$t('สิทธิ์การเข้าใช้งาน')"
      button-size="sm"
      size="sm"
      @ok="submitAbility"
    >
      <AbilityForm
        ref="abilityForm"
        :ability="ability"
        @onSubmit="onSubmit"
      />
    </b-modal>
    <TotpResetDialog ref="totpResetDialog" />
  </div>
</template>

<script>
/* eslint-disable */
import {
  BModal,
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import AbilityForm from '@/views/components/AbilityForm'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import agentService from '@/service/agentService'
import useJwt from '@/auth/jwt/useJwt'
import TotpResetDialog from './TotpResetDialog.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BModal,
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    AbilityForm,
    TotpResetDialog,
  },
  data() {
    return {
      small : true,
      abilityDisble: false,
      abilityUsername: '',
      ability: {},
      totpResettingUsername: '',
      loading: false,
      perPage: 25,
      pageOptions: [1, 5, 10, 25, 50, 100, 150, 250, 500],
      totalRows: 1,
      currentPage: 1,
      sortBy: 'createAt',
      sortDesc: false,
      sortDirection: 'asc',
      filter: '',
      filterForSearch: '',
      // filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'index',
          label: 'ลำดับ',
          sortable: true,
        },
        {
          key: 'prefix',
          label: 'Prefix',
        },
        {
          key: 'username',
          label: 'Username',
        },
        {
          key: 'nickName',
          label: 'NickName',
        },
        {
          key: 'ability',
          label: 'สิทธิ์การเข้าใช้งาน',
          class: 'text-nowrap text-center',
        },
        'edit',
        'delete',
        {
          key: 'isEnable',
          label: 'ระงับชั่วคราว',
          class: 'text-nowrap',
          formatter: v => (v ? 'NO' : 'YES'),
        },
        {
          key: 'createAt',
          label: 'Create At',
          class: 'text-nowrap',
        },
        {
          key: 'lastLoginAt',
          label: 'LastLogin',
          class: 'text-nowrap',
        },
        {
          key: 'lastLoginIp',
          label: 'LastIP',
          class: 'text-nowrap',
        },
      ],
    }
  },
  mounted() {
    const userData = this.$store.state.app.userData || {}
    const isBackOfficeRole = userData.role === 'admin' || userData.role === 'sub'
    const isMasterManageAll = isBackOfficeRole && userData.agent === 'master' && this.$can('manage', 'all')
    const shouldHideManagementColumns = isBackOfficeRole === false
      || this.$can('update', 'member') === false
      || (userData.role === 'sub' && isMasterManageAll === false)
    if (shouldHideManagementColumns) {
      this.fields.splice(4, 3)
      this.small = false;
    }
    if (this.canViewLoginSecurity()) {
      const insertIndex = this.fields.findIndex(v => v.key === 'isEnable')
      this.fields.splice(insertIndex === -1 ? this.fields.length : insertIndex, 0, {
        key: 'totpStatus',
        label: 'Two-factor authentication',
        class: 'text-nowrap text-center',
      })
    }
  },
  methods: {
    filterSearch() {
      this.filter = this.filterForSearch
    },
    canViewLoginSecurity() {
      return this.$can('read', 'loginSecurity') || this.$can('update', 'loginSecurity') || this.$can('manage', 'all')
    },
    canUpdateLoginSecurity() {
      return this.$can('update', 'loginSecurity') || this.$can('manage', 'all')
    },
    canResetTotp(item) {
      return item.totpRequired && item.totpEnabled && this.canUpdateLoginSecurity()
    },
    async attachTotpStatuses(list) {
      if (!this.canViewLoginSecurity() || list.length === 0) return

      try {
        const usernames = list.map(v => v.username)
        const statuses = new Map()
        const failedUsernames = new Set()
        for (let i = 0; i < usernames.length; i += 100) {
          const chunk = usernames.slice(i, i + 100)
          try {
            const response = await useJwt.loginSecurityTotpStatus({
              usernames: chunk,
            })
            const rows = response.data || []
            rows.forEach(v => statuses.set(v.username, v))
          } catch (error) {
            chunk.forEach(username => failedUsernames.add(username))
          }
        }
        list.forEach(item => {
          const status = statuses.get(item.username)
          item.totpRequired = status ? status.required : false
          item.totpEnabled = status ? status.enabled : false
          item.totpEnrolledAt = status ? status.enrolledAt : null
          item.totpStatusUnknown = failedUsernames.has(item.username)
        })
      } catch (error) {
        list.forEach(item => {
          item.totpRequired = false
          item.totpEnabled = false
          item.totpEnrolledAt = null
          item.totpStatusUnknown = true
        })
      }
    },
    getTotpStatusText(item) {
      if (item.totpStatusUnknown) return this.$t('Unable to load status')
      if (!item.totpRequired) return this.$t('Not required')
      return item.totpEnabled ? this.$t('Enabled') : this.$t('Not enrolled')
    },
    getTotpStatusVariant(item) {
      if (item.totpStatusUnknown) return 'danger'
      if (!item.totpRequired) return 'light-secondary'
      return item.totpEnabled ? 'success' : 'warning'
    },
    async resetTotp(item) {
      this.totpResettingUsername = item.username
      try {
        const resetCompleted = await this.$refs.totpResetDialog.open({
          username: item.username,
          submit: code => useJwt.loginSecurityTotpReset({
            username: item.username,
            code,
          }),
          getErrorMessage: this.getTotpResetErrorMessage,
        })

        if (!resetCompleted) return

        this.$refs.table.refresh()
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: this.$t('สำเร็จ'),
            icon: 'CheckIcon',
            variant: 'success',
            text: this.$t('Two-factor authentication reset successfully'),
          },
        })
      } finally {
        this.totpResettingUsername = ''
      }
    },
    getTotpResetErrorMessage(error) {
      const data = error.response && error.response.data
      return data && data.error && (data.error.code || data.error.username)
        ? this.translateMessage(data.error.code || data.error.username)
        : this.$t('Unable to reset two-factor authentication. Please try again')
    },
    translateMessage(text) {
      if (!text) return this.$t('Something wrong')
      const message = `${text}`
      const lockedMatch = message.match(/^.+ถูกล็อกชั่วคราว กรุณาลองใหม่ใน (\d+) วินาที$/)
      if (lockedMatch) {
        return this.$t('The authentication app is temporarily locked. Please try again in {seconds} seconds', {
          seconds: lockedMatch[1],
        })
      }
      return this.$t(message)
    },
    async getAbility(id) {
      this.abilityUsername = id
      const res = await agentService.getAuthen(`subAccount/ability?username=${id}`)
      if (res.status === 200) {
        this.abilityDisble = true
        this.ability = res.data
      }
    },
    async reloadData() {
      this.loading = true
      const startRow = (this.currentPage - 1) * this.perPage
      const res = await agentService.getAuthen(`subAccount?filter=${this.filter}&limit=${this.perPage}&page=${startRow}&sortBy=${this.sortBy}&desc=${this.sortDesc}`)
      if (res.status === 200) {
        this.totalRows = res.data.count
        this.loading = false
        const { list } = res.data
        if (this.sortDesc === false) {
          let index = startRow + 1
          for (let i = 0; i < list.length; i += 1) {
            list[i].index = index
            index += 1
          }
        } else {
          let index = res.data.count
          for (let i = 0; i < list.length; i += 1) {
            list[i].index = index
            index -= 1
          }
        }
        await this.attachTotpStatuses(list)
        return list
      }
      this.loading = false
      return []
    },
    submitAbility(e) {
      e.preventDefault()
      this.$refs.abilityForm.onSubmit()
    },
    onSubmit(v) {
      if (this.abilityUsername === '') {
        return
      }
      v = this.$refs.abilityForm.buildPermission(v);
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการบันทึกข้อมูลใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(async result => {
            if (result.value) {
              const res = await agentService.putAuthen(`subAccount/ability?username=${this.abilityUsername}`, v)
              if (res.status === 200) {
                this.abilityDisble = false
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('สำเร็จ'),
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: this.$t('บันทึกข้อมูสำเร็จ'),
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('เกิดข้อผิดพลาด'),
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                    text: this.$t('ขัดคล่อง โปรดลองใหม่ในภายหลัง'),
                  },
                })
              }
            }
          })
    },
    onDelete(username) {
      this.$swal({
        dark: true,
        title: this.$t('Are you sure?'),
        text: this.$t('คุณเเน่ใจว่าต้องการลบข้อมูลใช่หรือไม่'),
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: this.$t('Ok'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(async result => {
            if (result.value) {
              const res = await agentService.deleteAuthen(`subAccount?username=${username}`)
              if (res.status === 200) {
                this.$refs.table.refresh()

                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('สำเร็จ'),
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: this.$t('บันทึกข้อมูสำเร็จ'),
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: this.$t('เกิดข้อผิดพลาด'),
                    icon: 'AlertCircleIcon',
                    variant: 'danger',
                    text: this.$t('ขัดคล่อง โปรดลองใหม่ในภายหลัง'),
                  },
                })
              }
            }
          })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';

table {
  .sr-only {
    width: 0px !important;
  }
}
</style>
